
<form [formGroup]="addEditJobForm">
  <div class="row">
    <div class="col-md-12">
      <mat-form-field [color]="param.color">
        <input matInput placeholder="Nom" formControlName="name" class="form-control" id="name" required>
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <mat-form-field [color]="param.color">
        <input matInput placeholder="Adresse email" formControlName="mail" class="form-control" id="mail" required>
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <mat-form-field [color]="param.color">
        <input matInput placeholder="Numéro de mobile (sms gratuit)" formControlName="jobalert_portable" class="form-control" id="jobalert_portable">
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <mat-form-field [color]="param.color" appearance="legacy">
        <mat-label>Fonctions</mat-label>
        <mat-select panelClass="example-panel-{{param.color}}" formControlName="fonctionName" id="fonctionName" multiple>
          <mat-option *ngFor="let fonction of emploiFonction" value="{{fonction.idfonction}}">{{fonction.fonction}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <mat-form-field [color]="param.color" appearance="legacy">
        <mat-label>Région(s)</mat-label>
        <mat-select panelClass="example-panel-{{param.color}}" formControlName="regionName" id="regionName" multiple>
          <mat-option *ngFor="let regions of region" value="{{regions.idregion}}">{{regions.region}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

</form>
